// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".warning-confirmation[data-v-75410380] {\n  color: white;\n}[dir] .warning-confirmation[data-v-75410380] {\n  text-align: center;\n  background-color: #ff9800;\n  padding: 5px 10px;\n  border-radius: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
